import { Alert as ChakraAlert, CloseButton } from '@chakra-ui/react';
import { forwardRef } from 'react';
import type { StyleProps } from '../../../types';

import { AlertDefaultProps, type AlertProps } from './Alert.types';

const Alert = forwardRef<HTMLDivElement, AlertProps>(
  ({ children, title, variant, onClose, ...props }, ref) => {
    const AlertStyles: StyleProps = {
      borderRadius: '4px',
      ...(variant === 'outline' && { background: 'bg' }),
    };

    return (
      <ChakraAlert.Root ref={ref} variant={variant} {...AlertStyles} {...props}>
        <ChakraAlert.Indicator />
        <ChakraAlert.Content>
          {title && <ChakraAlert.Title>{title}</ChakraAlert.Title>}
          {children && <ChakraAlert.Description>{children}</ChakraAlert.Description>}
        </ChakraAlert.Content>
        {onClose && <CloseButton pos="relative" top="-2" insetEnd="-2" onClick={onClose} />}
      </ChakraAlert.Root>
    );
  }
);

Alert.displayName = 'Alert';
Alert.defaultProps = AlertDefaultProps;

export { Alert };
